import AbstractScene from './AbstractScene.js';
import ButtonArrowLarge from '../prefabs/buttons/ButtonArrowLarge.js';
import LevelBtn from '../prefabs/LevelBtn.js';

export default class Intro extends AbstractScene {
    constructor() {
        super({
            key: "Intro"
        })
    }
    init(data) {
        this._init(data);
    }

    preload() {
        this._preload();
    }


    // update(){

    // }

    create() {
        this.background = this.add.image(0, 0, 'introBackground').setOrigin(0, 0);
        this.ellipse = this.add.image(0, 400, 'ellipse').setOrigin(0)
        this.title = this.add.image(184, 430, 'introTitle').setOrigin(0);
        this.logo = this.add.image(50, -82, 'logoNovotelWwf').setOrigin(0);

        this.titleCart = this.add.image(50, -61, 'introTitleCart').setOrigin(0);

        this.tweens.add({
            targets: this.logo,
            duration: 500,
            ease: 'Cubic.easeInOut',
            y: -1,
        });

        this.btn = new ButtonArrowLarge(this, 184 + 245, 790, 490, 97, "Démarrer l'aventure");
        this.btn.setClickFunction(() => {
            this.firstClickAction()
        });
    }

    firstClickAction() {
        this.tweens.add({
            targets: this.logo,
            duration: 500,
            ease: 'Cubic.easeInOut',
            y: -82,
            onComplete: () => {

            }
        });

        this.tweens.add({
            targets: this.background,
            duration: 1500,
            ease: 'Sine.easeInOut',
            y: (this.background.y - 755),
            onComplete: () => {
            }
        });
        [this.title, this.ellipse, this.btn].forEach((el, index) => {
            this.tweens.add({
                targets: el,
                duration: 1500,
                ease: 'Sine.easeInOut',
                y: (el.y - 900),
                onComplete: () => {

                    if (index === 2) {
                        this.launchCta()
                        this.tweens.add({
                            targets: this.titleCart,
                            duration: 500,
                            ease: 'Cubic.easeInOut',
                            y: -1,
                        });
                    }
                }
            });
        });
    }

    launchCta() {
        console.log('Animation complete, launching CTA');
        this.btn1 = new LevelBtn(this, this.width / 2 - 240, this.height / 2, 0)
        this.btn2 = new LevelBtn(this, this.width / 2 + 240, this.height / 2, 1)

        this.btn1.launchAnim()
        this.time.addEvent({
            delay: 900,
            callback: () => {
                this.btn2.launchAnim()
            }
        })
    }


}
